import { watch } from "vue";
import { usePrototypeConfigStore } from "@/store/prototypeConfig";

export default defineNuxtPlugin((app) => {
    // This plugin only runs on the client side due to the .client suffix
    const store = usePrototypeConfigStore();
    const { $setStorageItem } = app;
    const localStorageKey = "localSettingsPrototype"; // Ensure key matches the one used in the store

    // Watch the entire state for changes and save to localStorage
    watch(
        store.$state,
        (newState) => {
            $setStorageItem(localStorageKey, newState, "Failed to save prototype config to localStorage from plugin");
        },
        { deep: true }, // Watch nested properties
    );
});
